module.exports = __webpack_public_path__ + "img/img_zhihu_qrcode.8be38175.svg";